<template>
  <div
    class="d-flex flex-row flex-wrap align-items-center justify-content-start"
  >
    <div class="mr-4 mb-3">
      <span>
        <span class="c-charcoal">{{ day }}</span> - {{ date }}
      </span>
    </div>
    <div class="mb-3">
      <span class="c-charcoal">{{ startTime }}</span>
      {{ $t('GENERAL.LABEL.YOUR_TIME') }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'StudioEventDateTimeComponent',
  props: {
    day: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
